import { render } from "./designfoodslide2.vue?vue&type=template&id=7255eab1&scoped=true"
import script from "./designfoodslide2.vue?vue&type=script&lang=js"
export * from "./designfoodslide2.vue?vue&type=script&lang=js"

import "./designfoodslide2.vue?vue&type=style&index=0&id=7255eab1&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7255eab1"]])

export default __exports__